/* eslint-disable no-unused-expressions */
import Decimal from 'decimal.js';
import { QUANTITY } from '@Apis/constants';

export const getBatchesWithReservation = (oldBaches, quantity, prLine, isGoodStockOnly, lineKey, resetNotRequired, cBatchId, cBatchQty) => {
  const batches = [];
  let remainingQty = Number(quantity);
  const staticReservations = JSON.parse(sessionStorage.getItem('staticReservations'));
  const staticReservationCopy = JSON.parse(JSON.stringify(staticReservations));

  const clearLineReservations = () => {
    if (cBatchId) {
      // Delete only the specified batchKey for the given lineKey if cBatchId is present
      delete staticReservationCopy?.[cBatchId]?.[lineKey];
    } else {
      // Delete all batchKeys for the given lineKey
      Object.keys(staticReservationCopy)?.forEach((batchKey) => (
        delete staticReservationCopy?.[batchKey]?.[lineKey]
      ));
    }
  };

  clearLineReservations();

  const getBatchReservations = (batchId) => {
    let total = new Decimal(0);
  
    if (
      Object.prototype.hasOwnProperty.call(staticReservationCopy, Number(batchId)) &&
      Object.keys(staticReservationCopy[batchId] || {})?.length > 0
    ) {
      Object.keys(staticReservationCopy[batchId])?.forEach((item) => {
        total = total.plus(staticReservationCopy[batchId][item] || 0);
      });
    }
  
    return {
      total: total.toNumber(),
      reservations: staticReservationCopy[batchId],
    };
  };

  const addBatchReservation = (batchId, qty) => {
    const batchKey = Number(batchId);
  
    if (Object.prototype.hasOwnProperty.call(staticReservationCopy, batchKey)) {
      if (Object.prototype.hasOwnProperty.call(staticReservationCopy[batchKey], lineKey)) {
        const existingQty = new Decimal(staticReservationCopy[batchKey][lineKey] || 0);
        const newQty = existingQty.plus(qty || 0);
        staticReservationCopy[batchKey][lineKey] = newQty.toNumber();
      } else {
        staticReservationCopy[batchKey][lineKey] = new Decimal(qty || 0).toNumber();
      }
    } else {
      staticReservationCopy[batchKey] = {
        [lineKey]: new Decimal(qty || 0).toNumber(),
      };
    }
  };

  for (let i = 0; i < oldBaches?.length; i++) {
    const batchReservations = getBatchReservations(oldBaches[i]?.batch_id);
    batches.push({
      ...oldBaches[i],
      consumed_qty: cBatchId ? (oldBaches[i].consumed_qty || 0) : 0,
      // available_qty: Number((oldBaches[i]?.available_qty / prLine?.uom_info?.ratio) * prLine?.product_sku_info?.uom_info?.ratio),
      batch_in_use: !resetNotRequired ? oldBaches[i].batch_in_use : true,
      _reserved: batchReservations,
    });
  }

  if (cBatchId) {
    // Allocate the given cBatchQty to the corresponding batch
    for (let i = 0; i < batches?.length; i++) {
      if (batches[i]?.batch_id === cBatchId) {
        const avlQty = ((Number(batches?.[i]?.available_qty) / prLine?.uom_info?.ratio) * prLine?.product_sku_info?.uom_info?.ratio) - Number(batches?.[i]?._reserved?.total);
        const allocatedQty = Math.min(Number(cBatchQty), avlQty);
        batches[i].consumed_qty = allocatedQty;
        remainingQty -= allocatedQty;
        addBatchReservation(batches[i]?.batch_id, allocatedQty);
        break; // Exit the loop since we have allocated the quantity
      }
    }
  } else {
    for (let i = 0; i < batches?.length; i++) {
      if (isGoodStockOnly && batches?.[i]?.is_rejected_batch) continue;
  
      const availableQty = new Decimal(QUANTITY(batches?.[i]?.available_qty, prLine?.uom_info?.precision)|| 0);
      const reservedQty = new Decimal(batches?.[i]?._reserved?.total || 0);
      const prUOMRatio = new Decimal(prLine?.uom_info?.ratio || 1);
      const skuUOMRatio = new Decimal(prLine?.product_sku_info?.uom_info?.ratio || 1);
  
      const avlQty = availableQty
        .div(prUOMRatio)
        .mul(skuUOMRatio)
        .minus(reservedQty);
  
      if (batches?.[i]?.batch_in_use) {
        const remaining = new Decimal(remainingQty);
        if (remaining.gt(0) && new Decimal(batches[i]?.consumed_qty || 0).lt(avlQty)) {
          const consumeQty = Decimal.min(avlQty, remaining);
          batches[i].consumed_qty = consumeQty.toNumber();
          remainingQty = remaining.minus(consumeQty).toNumber();
          addBatchReservation(batches[i]?.batch_id, consumeQty.toNumber());
        } else {
          batches[i].consumed_qty = 0;
          remainingQty = new Decimal(remainingQty).minus(0).toNumber();
        }
      }
    }
  }

  sessionStorage.setItem('staticReservations', JSON.stringify(staticReservationCopy));

  const finalBatches = batches?.map((item) => ({ ...item, _reserved: getBatchReservations(item?.batch_id) }));

  return finalBatches;
  // return batches;
};

export const clearReservationsByLine = (lineKey) => {
  const staticReservations = JSON.parse(sessionStorage.getItem('staticReservations'));
  const staticReservationCopy = JSON.parse(JSON.stringify(staticReservations));
  Object.keys(staticReservationCopy)?.forEach((batchKey) => {
    if (staticReservationCopy?.[batchKey]?.[lineKey] !== undefined) {
      delete staticReservationCopy?.[batchKey]?.[lineKey];
    }
  });
  sessionStorage.setItem('staticReservations', JSON.stringify(staticReservationCopy));
};
